import { useCallback, useContext } from 'react';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import DataRoomDocumentsContext from '../providers/DataRoomDocuments/DataRoomDocuments.context';
import DataRoomSelectedDocumentsContext from '../providers/DataRoomSelectedDocuments/DataRoomSelectedDocuments.context';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';

type UseRenameProps = {
  id: string;
  onRenameSuccess?: () => void;
};

const useRenameFile = (props: UseRenameProps) => {
  const { id, onRenameSuccess } = props;

  const { popServerError } = useContext(PopNotificationsContext);
  const { removeAll } = useContext(DataRoomSelectedDocumentsContext);
  const { updateNodeById, sortCurrentlyDisplayedNodes } = useContext(
    DataRoomDocumentsContext,
  );
  const {
    dataRoom: { _id: dataRoomId },
  } = useContext(DataRoomContext);

  const onRenameFile = useCallback(
    async ({ name }) => {
      try {
        const { data } = await dataRoomApi.nodes.patchDataRoomNode(
          id,
          dataRoomId,
          { name },
        );

        updateNodeById(id, data);
        sortCurrentlyDisplayedNodes();
        removeAll();
        onRenameSuccess?.();
      } catch (e) {
        popServerError(e);
      }
    },
    [
      dataRoomId,
      id,
      onRenameSuccess,
      popServerError,
      removeAll,
      sortCurrentlyDisplayedNodes,
      updateNodeById,
    ],
  );

  return onRenameFile;
};

export default useRenameFile;
